import { OutlineButton } from "Components/HomeV2/Buttons";
import ContainedButton from "Components/HomeV2/Buttons/Contained";
import { useIntersectionObserver } from "hooks";
import { FC, RefObject, forwardRef, useEffect, useState } from "react";
import aiText from "../../Assets/AIOnDemand/AI-text.png";
import image from "../../Assets/AIOnDemand/main-hero.png";
import bgImage from "../../Assets/homev2/el-bg.png";
interface NumberAnimatorProps {
    num: number;
    duration?: number;
}

const NumberAnimator = forwardRef<HTMLDivElement, NumberAnimatorProps>(
    ({ num, duration = 3500 }, ref) => {
        const [newNum, setNewNum] = useState<number>(0);
        const [trigger, setTrigger] = useState(false);
        const entry = useIntersectionObserver(ref as RefObject<Element>, {});
        const isVisible = !!entry?.isIntersecting;

        useEffect(() => {
            if (isVisible) {
                setTrigger(true);
            }
        }, [isVisible]);

        useEffect(() => {
            if (trigger) {
                const numberInterval = setTimeout(
                    () => setNewNum(newNum < num ? newNum + 1 : num),
                    duration / num
                );
                return () => {
                    clearTimeout(numberInterval);
                };
            }
        }, [newNum, trigger]);

        return <>{newNum}</>;
    }
);

const Hero: FC = () => {
    return (
        <section
            className="w-full bg-cover bg-no-repeat bg-bottom overflow-hidden max-h-[911px] relative"
            style={{
                backgroundImage: `url(${bgImage})`,
            }}
        >
            <div className="w-full h-full max-w-[1500px] mx-auto px-4 pt-8 md:pt-20 flex flex-col justify-between gap-4 lg:gap-8 items-center">
                <div>
                    <h2 className="text-3xl flex flex-row items-center justify-center gap-4 md:text-5xl lg:text-7xl text-black font-semibold text-center">
                        Revenue Growth
                        <img src={aiText} alt="AI" className="h-full w-auto object-contain max-h-8 sm:max-h-none" />
                    </h2>
                    <h4 className="text-center text-black md:text-2xl mt-4">
                        Custom AI Agents & Automation to Supercharge your B2B Sales Pipeline
                    </h4>
                    <div className="flex  max-w-[180px] items-center flex-col md:flex-row gap-4 md:gap-6 md:max-w-max md:w-max mx-auto  mb-14 md:mb-0 mt-4 md:mt-10">
                        <a
                            href="https://calendly.com/salesbox-meet/ai-ondemand"
                            className="w-full"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <ContainedButton theme="primary">
                                <span className="flex items-center gap-2 text-black">
                                    Book a Call
                                </span>
                            </ContainedButton>
                        </a>
                        <a
                            href="/ai-ondemand-sales-automation"
                            className="w-full"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <OutlineButton theme="black">What's Inside</OutlineButton>
                        </a>
                    </div>
                </div>
                <div className=" relative max-w-[1400px] px-10 -mt-10">
                    <img
                        src={image}
                        alt="Customize my solution"
                        width="100%"
                        height="100%"
                        loading="lazy"
                        className="object-contain"
                    />
                </div>
            </div>

        </section>
    );
};

export default Hero;
